import React from 'react';
import StatusBadge from '../../common/StatusBadge';
import { getPlayerNameColor } from '../../../utils/playerUtils';
import { demoLiveCourt, demoUpNext } from './landingDemoData';

const formatElo = (elo) => elo.toLocaleString();

const DemoPlayerRow = ({ player, compact = false }) => (
  <div className={`flex items-center justify-between gap-2 ${compact ? 'text-[11px]' : 'text-sm'}`}>
    <span className={`truncate ${getPlayerNameColor(player.gender)}`}>{player.name}</span>
    <span className="shrink-0 tabular-nums text-text-secondary">{formatElo(player.elo)}</span>
  </div>
);

const DemoTeamBlock = ({ team, teamNumber, compact = false }) => {
  const isTeam1 = teamNumber === 1;
  return (
    <div
      className={`rounded-xl border-l-4 bg-surface-subtle ${
        isTeam1 ? 'border-team1' : 'border-team2'
      } ${compact ? 'px-2.5 py-2' : 'px-3 py-2.5'}`}
    >
      <div
        className={`mb-1.5 flex items-center justify-between font-semibold ${
          isTeam1 ? 'text-team1' : 'text-team2'
        } ${compact ? 'text-[10px]' : 'text-xs'}`}
      >
        <span>Team {teamNumber}</span>
        {team.avgElo != null && (
          <span className="tabular-nums font-medium text-text-muted">Avg {formatElo(team.avgElo)}</span>
        )}
      </div>
      <div className="space-y-1">
        {team.players.map((player) => (
          <DemoPlayerRow key={player.name} player={player} compact={compact} />
        ))}
      </div>
    </div>
  );
};

const DemoMatchSides = ({ team1, team2, compact = false }) => (
  <div className={compact ? 'space-y-1.5' : 'space-y-2'}>
    <DemoTeamBlock team={Array.isArray(team1) ? { players: team1 } : team1} teamNumber={1} compact={compact} />
    <div className="flex items-center gap-2" aria-hidden="true">
      <div className="h-px min-w-0 flex-1 bg-border-medium" />
      <span className="text-[10px] font-semibold uppercase tracking-wide text-text-muted">vs</span>
      <div className="h-px min-w-0 flex-1 bg-border-medium" />
    </div>
    <DemoTeamBlock team={Array.isArray(team2) ? { players: team2 } : team2} teamNumber={2} compact={compact} />
  </div>
);

const LandingLiveSessionMockup = () => (
  <div className="relative" aria-hidden="true">
    <div className="overflow-hidden rounded-2xl border border-border-medium bg-surface shadow-brand-lg">
      <div className="flex items-center gap-2 bg-[#0e1624] px-4 py-2.5">
        <img src="/latest_icon.png" alt="" className="h-5 w-5 rounded" />
        <span className="text-xs font-semibold text-white">Shuttlr</span>
        <span className="ml-3 hidden text-[11px] text-white/60 sm:inline">Live session</span>
      </div>

      <div className="bg-background p-4 sm:p-5">
        <div className="rounded-2xl border border-border-medium bg-surface p-3 shadow-brand-sm sm:p-4">
          <div className="mb-3 flex items-center justify-between gap-2">
            <p className="text-sm font-semibold text-text-primary sm:text-base">{demoLiveCourt.label}</p>
            <div className="flex items-center gap-2">
              <span className="tabular-nums text-sm font-semibold text-text-primary">
                {demoLiveCourt.score[0]} – {demoLiveCourt.score[1]}
              </span>
              <StatusBadge variant="success" size="small">
                Playing
              </StatusBadge>
            </div>
          </div>
          <DemoMatchSides team1={demoLiveCourt.team1} team2={demoLiveCourt.team2} />
        </div>

        <div className="mt-3 rounded-2xl border border-dashed border-border-medium bg-surface p-3 shadow-brand-sm">
          <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-text-muted">
            {demoUpNext.label}
          </p>
          <DemoMatchSides team1={demoUpNext.team1} team2={demoUpNext.team2} compact />
        </div>
      </div>
    </div>
  </div>
);

export default LandingLiveSessionMockup;
